import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import jwt_decode from "jwt-decode";
import moment from "moment";

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views

//Analytics views
const AnalyticsDasboard = () => import("@/views/analytics");
const ChartPage = () => import("@/views/analytics/ChartPage");

//catalogos

//dispositivos
const NuevoDispositivo = () =>
  import("@/views/catalogos/dispositivos/NuevoDispositivo");
const Dispositivos = () =>
  import("@/views/catalogos/dispositivos/Dispositivos");

// const Indicadores = () => import("@/views/Indicadores");
const HomePage = () => import("@/views/HomePage");
const PlanningPage = () => import("@/views/PlanningPage");
const ChangePasswordPage = () => import("@/views/ChangePasswordPage");

// Views Reports
const ReportsPage = () => import("@/views/ReportsPage");
const ReportsPdf = () => import("../views/reportes/pdf/ReportPagePDF");
const AnalisisUbicacion = () =>
  import("@/views/reportes/analisis/AnalisisUbicacion");
const AnalisisNomina = () => import("@/views/reportes/analisis/AnalisisNomina");
const AnalisisEficiencia = () =>
  import("@/views/reportes/analisis/AnalisisEficiencia");

// Views Indicadores
//const Indicadores = () => import("@/views/Indicadores");
const Egresos = () => import("@/views/indicadores/administrativos/Egresos");
const EgresosAcumulados = () =>
  import("@/views/indicadores/administrativos/EgresosAcumulados");
const Ingresos = () => import("@/views/indicadores/administrativos/Ingresos");
const IngresosAcumulados = () =>
  import("@/views/indicadores/administrativos/IngresosAcumulados");
const IndicadoresAdmin = () =>
  import("@/views/indicadores/administrativos/IndicadoresAdmin");

const Comparativa = () =>
  import("@/views/indicadores/administrativos/Comparativa");

const CantidadAct = () => import("@/views/indicadores/operativos/CantidadAct");
const CantidadActAcumulados = () =>
  import("@/views/indicadores/operativos/CantidadActAcumulados");
const ProduccionIndicador = () =>
  import("@/views/indicadores/operativos/ProduccionIndicador");
const ProduccionIndicadorAcumulada = () =>
  import("@/views/indicadores/operativos/ProduccionIndicadorAcumulados");
const IndicadoresOperativos = () =>
  import("@/views/indicadores/operativos/IndicadoresOperativos");

// Views- Operaciones Aplicadas
const BonoAplicado = () =>
  import("@/views/operaciones/aplicados-bonos/BonoAplicado");
const VerBonoAplicado = () =>
  import("@/views/operaciones/aplicados-bonos/VerBonoAplicado");
const PrestamoAplicado = () =>
  import("@/views/operaciones/aplicados-prestamos/PrestamoAplicado");
const VerPrestamoAplicado = () =>
  import("@/views/operaciones/aplicados-prestamos/VerPrestamoAplicado");
const CajaAhorroAplicado = () =>
  import("@/views/operaciones/aplicados-caja-ahorro/CajaAhorroAplicado");
const VerCajaAhorroAplicado = () =>
  import("@/views/operaciones/aplicados-caja-ahorro/VerCajaAhorroAplicado");

// Views - Operaciones
const Asistencia = () => import("@/views/operaciones/asistencias/Asistencia");
const NuevoAsistencia = () =>
  import("@/views/operaciones/asistencias/NuevoAsistencia");
const VerAsistencia = () =>
  import("@/views/operaciones/asistencias/VerAsistencia");

const Jornada = () => import("@/views/operaciones/jornada/Jornada");
const VerJornada = () => import("@/views/operaciones/jornada/VerJornada");
const BitacoraJornadas = () =>
  import("@/views/operaciones/jornada/BitacoraJornadas");

const Prestacion = () => import("@/views/operaciones/prestaciones/Prestacion");
const VerPrestacion = () =>
  import("@/views/operaciones/prestaciones/VerPrestacion");
const CalculoAdministrativo = () =>
  import("@/views/operaciones/calculos-administrativos/CalculoAdministrativo");
const VerCalculoAdministrativo = () =>
  import(
    "@/views/operaciones/calculos-administrativos/VerCalculoAdministrativo"
  );
const CalculoAdministrativoNomina = () =>
  import(
    "@/views/operaciones/calculos-administrativos/CalculoAdministrativoNomina"
  );
const VerCalculoAdministrativoNomina = () =>
  import(
    "@/views/operaciones/calculos-administrativos/VerCalculoAdministrativoNomina"
  );
const BitacoraNomina = () => import("@/views/operaciones/calculos-administrativos/BitacoraNomina");

const BitacoraLabores = () =>
  import("@/views/operaciones/labores/BitacoraLabores");

// Views - Operaciones Grids
const Bono = () => import("@/views/operaciones/Bono");
const CajaAhorro = () => import("@/views/operaciones/CajaAhorro");
const Entrada = () => import("@/views/operaciones/Entrada");
const Entrega = () => import("@/views/operaciones/Entrega");
const Gasto = () => import("@/views/operaciones/Gasto");
const Labor = () => import("@/views/operaciones/Labor");
const Riego = () => import("@/views/operaciones/Riego");
const Prestamo = () => import("@/views/operaciones/Prestamo");
const Produccion = () => import("@/views/operaciones/Produccion");
const Salida = () => import("@/views/operaciones/Salida");
const Depuraciones = () => import("@/views/operaciones/Depuraciones");
const SolicitudEmpaque = () => import("@/views/operaciones/SolicitudEmpaque");
const DevolucionEmpaque = () => import("@/views/operaciones/DevolucionEmpaque");

// Views - Catalogos
const Actividades = () => import("@/views/catalogos/Actividades");
const ActividadesCostos = () => import("@/views/catalogos/ActividadesCostos");
const Almacenes = () => import("@/views/catalogos/Almacenes");
const Cultivos = () => import("@/views/catalogos/Cultivos");
const Empaques = () => import("@/views/catalogos/Empaques");
const Empresas = () => import("@/views/catalogos/Empresas");
const Perfiles = () => import("@/views/catalogos/Perfiles");
const Productos = () => import("@/views/catalogos/Productos");
const Puestos = () => import("@/views/catalogos/Puestos");
const Servicios = () => import("@/views/catalogos/Servicios");
const Trabajadores = () => import("@/views/catalogos/Trabajadores");
const Clientes = () => import("@/views/catalogos/Clientes");
const Proveedores = () => import("@/views/catalogos/Proveedores");
const Ubicaciones = () => import("@/views/catalogos/Ubicaciones");
const Usuarios = () => import("@/views/catalogos/Usuarios");

// Views - Nuevos
const NuevoBono = () => import("@/views/nuevos/NuevoBono");
const NuevoBonos = () => import("@/views/nuevos/NuevoBonos");
const NuevoCajaAhorro = () => import("@/views/nuevos/NuevoCajaAhorro");
const NuevoLote = () => import("@/views/nuevos/NuevoLote");
const NuevoLabor = () => import("@/views/nuevos/NuevoLabor");
const NuevoLabores = () => import("@/views/nuevos/NuevoLabores");
const NuevoRiego = () => import("@/views/operaciones/Riego/NuevoRiego");
const NuevoRiegos = () => import("@/views/operaciones/Riego/NuevoRiegos");
const NuevoPrestamo = () => import("@/views/nuevos/NuevoPrestamo");
const NuevoProrroga = () => import("@/views/nuevos/NuevoProrroga");
const NuevaProrrogaCA = () => import("@/views/nuevos/NuevaProrrogaCA");
const NuevoPagoCA = () => import("@/views/nuevos/NuevoPagoCA");
const NuevoProduccion = () => import("@/views/nuevos/NuevoProduccion");
const NuevoProducciones = () => import("@/views/nuevos/NuevoProducciones");
const NuevoEmpresa = () => import("@/views/nuevos/NuevoEmpresa");
const NuevoEmpaques = () => import("@/views/nuevos/NuevoEmpaques");
const NuevoEntrega = () => import("@/views/nuevos/NuevoEntrega");
const NuevoEntregas = () => import("@/views/nuevos/NuevoEntregas");
const NuevoEntrada = () => import("@/views/nuevos/NuevoEntrada");
const NuevoSalida = () => import("@/views/nuevos/NuevoSalida");
const NuevoGasto = () => import("@/views/nuevos/NuevoGasto");
const NuevoPerfil = () => import("@/views/nuevos/NuevoPerfil");
const NuevoCultivo = () => import("@/views/nuevos/NuevoCultivo");
const NuevoTrabajador = () => import("@/views/nuevos/NuevoTrabajador");
const NuevoCliente = () => import("@/views/nuevos/NuevoCliente");
const NuevoProveedor = () => import("@/views/nuevos/NuevoProveedor");
const NuevoServicio = () => import("@/views/nuevos/NuevoServicio");
const NuevoAlmacen = () => import("@/views/nuevos/NuevoAlmacen");
const NuevoProducto = () => import("@/views/nuevos/NuevoProducto");
const NuevoPuesto = () => import("@/views/nuevos/NuevoPuesto");
const NuevoActividad = () => import("@/views/nuevos/NuevoActividad");
const NuevoUbicacion = () => import("@/views/nuevos/NuevoUbicacion");
const NuevoUsuario = () => import("@/views/nuevos/NuevoUsuario");
const NuevoSolicitudEmpaque = () =>
  import("@/views/nuevos/NuevoSolicitudEmpaque");
const NuevoDevolucionEmpaque = () =>
  import("@/views/nuevos/NuevoDevolucionEmpaque");

// Views - Editar
const EditarLote = () => import("@/views/editar/EditarLote");
const EditarCultivo = () => import("@/views/editar/EditarCultivo");
const EditarTrabajador = () => import("@/views/editar/EditarTrabajador");
const EditarCliente = () => import("@/views/editar/EditarCliente");
const EditarProveedor = () => import("@/views/editar/EditarProveedor");
const EditarAlmacen = () => import("@/views/editar/EditarAlmacen");
const EditarActividad = () => import("@/views/editar/EditarActividad");
const EditarEmpresa = () => import("@/views/editar/EditarEmpresa");
const EditarEmpaques = () => import("@/views/editar/EditarEmpaques");
const EditarProducto = () => import("@/views/editar/EditarProducto");
const EditarPuesto = () => import("@/views/editar/EditarPuesto");
const EditarServicio = () => import("@/views/editar/EditarServicio");
const EditarUbicacion = () => import("@/views/editar/EditarUbicacion");
const EditarUsuario = () => import("@/views/editar/EditarUsuario");
const EditarPerfilPermisos = () =>
  import("@/views/editar/EditarPerfilPermisos");

// Views - Ver
const VerBono = () => import("@/views/ver/VerBono");
const VerLabor = () => import("@/views/ver/VerLabor");
const VerRiego = () => import("@/views/operaciones/Riego/VerRiego");
const VerPrestamo = () => import("@/views/ver/VerPrestamo");
const VerProduccion = () => import("@/views/ver/VerProduccion");
const VerEntrega = () => import("@/views/ver/VerEntrega");
const VerEntrada = () => import("@/views/ver/VerEntrada");
const VerSalida = () => import("@/views/ver/VerSalida");
const VerGasto = () => import("@/views/ver/VerGasto");
const VerCajaAhorro = () => import("@/views/ver/VerCajaAhorro");
const VerSolicitudEmpaque = () => import("@/views/ver/VerSolicitudEmpaque");
const VerDevolucionEmpaque = () => import("@/views/ver/VerDevolucionEmpaque");

// Views - Consultas
const Costos = () => import("@/views/consultas/Costos");
const InventarioActual = () => import("@/views/consultas/InventarioActual");
const InventarioDetallado = () =>
  import("@/views/consultas/InventarioDetallado");
const InventarioHistorico = () =>
  import("@/views/consultas/InventarioHistorico");
const InventarioHistoricoDetallado = () =>
  import("@/views/consultas/InventarioHistoricoDetallado");

// Views - Pages
const Error500Page = () => import("@/views/Error500Page");
const Login = () => import("@/views/Login");
const Recovery = () => import("@/views/PasswordRecoveryPage");
const AvisoPrivacidad = () => import("@/views/AvisoPrivacidad");
const RecoveryPsChange = () => import("@/views/RecoveryPsChange");
const PanelPage = () => import("@/views/PanelPage");
const ManagerPage = () => import("@/views/ManagerPage");
const OperacionesPage = () => import("@/views/OperacionesPage");
const GestionLabores = () => import("@/views/GestionLabores");

// Catalogo operadores
const Operadores = () => import("@/views/catalogos/operadores/IndexOperador");
const NuevoOperador = () =>
  import("@/views/catalogos/operadores/NuevoOperador");
const EditarOperador = () =>
  import("@/views/catalogos/operadores/EditarOperador");

//
const Requisiciones = () =>
  import("@/views/operaciones/requisiciones/IndexRequisicion");
const NuevaRequisicion = () =>
  import("@/views/operaciones/requisiciones/NuevaRequisicion");
const VerRequisicion = () =>
  import("@/views/operaciones/requisiciones/VerRequisicion");

//
const Traspasos = () => import("@/views/operaciones/traspasos/IndexTraspaso");
const NuevoTraspaso = () =>
  import("@/views/operaciones/traspasos/NuevoTraspaso");
const VerTraspaso = () => import("@/views/operaciones/traspasos/VerTraspaso");

//
const OrdenesCompra = () =>
  import("@/views/operaciones/ordenes-compra/IndexOrdenesCompra");
const NuevaOrdenCompra = () =>
  import("@/views/operaciones/ordenes-compra/NuevaOrdenCompra");
const VerOrdenCompra = () =>
  import("@/views/operaciones/ordenes-compra/VerOrdenCompra");
const SurtirOrdenCompra = () =>
  import("@/views/operaciones/ordenes-compra/SurtirOrdenCompra");

Vue.use(Router);

const router = new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function validateToken() {
  const token = store.getters.gToken;

  if (token) {
    try {
      // const date = moment();
      const decode = jwt_decode(token);
      // date.setUTCSeconds(decode.exp);
      // console.log(date);
      const expDate = moment(Number(`${decode.exp}000`));
      // console.log(token);
      // const actualDate = new Date();

      // actualDate.setDate(date.getDate() + 2);
      // console.log(actualDate);
      // console.log(moment().isSameOrAfter(expDate));
      const diff = moment().isSameOrBefore(expDate);

      if(!diff){
        console.log('token expirado, revisar fecha de la computadora y/o servidor');
      }
      return diff
      // return true;
    } catch (error) {
      // console.log(false);

      return false;
    }
  } else {
    // console.log(false);

    return false;
  }
}
function hasTheCredential(credential, next) {
  const gCredential = store.getters.allCredenciales;
  const regex = new RegExp(credential, "i");
  const test = gCredential.some((s) => regex.test(s));
  return test?next():next({ name: "Home"});
}

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/home",
      name: "Home",
      component: TheContainer,
      beforeEnter: (to, from, next) => {
        validateToken() ? next() : next({ name: "Login" });
      },
      children: [
        {
          path: "/home",
          name: "HomePage",
          component: HomePage,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "/panel",
          name: "Panel",
          component: PanelPage,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "/correcciones",
          name: "Correcciones",
          component: ManagerPage,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "/change-password",
          name: "change",
          component: ChangePasswordPage,
        },
        {
          path: "/usuarios",
          name: "usuarios",
          component: Usuarios,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "/usuario-nuevo",
          name: "NuevoUsuario",
          component: NuevoUsuario,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "editar-usuario/:id",
          name: "EditarUsuario",
          component: EditarUsuario,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "/perfiles",
          name: "perfiles",
          component: Perfiles,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "/perfiles/perfil-nuevo",
          name: "NuevoPerfil",
          component: NuevoPerfil,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "perfi/editar-perfil/:id",
          name: "EditarPerfilPermisos",
          component: EditarPerfilPermisos,
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
        },
        {
          path: "reports",
          redirect: "/reports/form",
          name: "ReportsPage",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "form",
              name: "Form",
              component: ReportsPage,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "pdf",
              name: "Pdf",
              component: ReportsPdf,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "analisis",
              name: "Analisis",
              component: AnalisisUbicacion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "analisis_nomina",
              name: "AnalisisNomina",
              component: AnalisisNomina,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "analisis_eficiencia",
              name: "AnalisisEficiencia",
              component: AnalisisEficiencia,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
          ],
        },
        {
          path: "planeacion",
          redirect: "/planning/section",
          name: "PlanningPage",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "lotes",
              name: "Section",
              component: PlanningPage,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "lote-nuevo",
              name: "NuevoLote",
              component: NuevoLote,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-lote/:id",
              name: "EditarLote",
              component: EditarLote,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
          ],
        },
        {
          path: "indicadores",
          redirect: "/indicadores/administrativos/ingresos",
          name: "Indicadores",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          beforeEnter: (to, from, next) => {
            validateToken() ? next() : next({ name: "Login" });
          },
          children: [
            {
              path: "administrativos/ingresos",
              name: "Ingresos",
              component: Ingresos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "administrativos/ingresos_acumulados",
              name: "IngresosAcumulados",
              component: IngresosAcumulados,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "administrativos/egresos",
              name: "Egresos",
              component: Egresos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "administrativos/egresos_acumulados",
              name: "EgresosAcumulados",
              component: EgresosAcumulados,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "administrativos/indicadores_admin",
              name: "IndicadoresAdmin",
              component: IndicadoresAdmin,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "administrativos/comparativa",
              name: "Comparativa",
              component: Comparativa,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operativos/produccion",
              name: "ProduccionIndicador",
              component: ProduccionIndicador,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operativos/produccion_acumulada",
              name: "ProduccionIndicadorAcumulada",
              component: ProduccionIndicadorAcumulada,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operativos/cantidad_actividad",
              name: "CantidadAct",
              component: CantidadAct,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operativos/cantidad_actividad_acumulados",
              name: "CantidadActAcumulados",
              component: CantidadActAcumulados,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operativos/indicadores_operativos",
              name: "IndicadoresOperativos",
              component: IndicadoresOperativos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "analytics",
              name: "AnalyticsPanel",
              component: AnalyticsDasboard,
              beforeEnter: (to, from, next) => {
                validateToken()
                  ? hasTheCredential(
                      "@view:schema=analytics\\|.*consultar",
                      next
                    )
                  : next({ name: "Login" });
              },
            },
            {
              path: "analytics/chart/:reporte",
              name: "AnalyticsChart",
              component: ChartPage,
              beforeEnter: (to, from, next) => {
                validateToken()
                  ? hasTheCredential(
                      "@view:schema=analytics\\|.*consultar",
                      next
                    )
                  : next({ name: "Login" });
              },
            },
          ],
        },
        {
          path: "operaciones",
          redirect: "/operaciones/",
          name: "operaciones",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Operaciones",
              component: OperacionesPage,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "produccion",
              name: "Produccion",
              component: Produccion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "produccion-nuevo",
              name: "NuevoProduccion",
              component: NuevoProduccion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "producciones-nuevo",
              name: "NuevoProducciones",
              component: NuevoProducciones,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "edit-produccion/:folio",
              name: "EditProduccion",
              component: NuevoProduccion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-produccion/:id",
              name: "VerProduccion",
              component: VerProduccion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "labor",
              name: "Labor",
              component: Labor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "bitacora-labor",
              name: "BitacoraLabores",
              component: BitacoraLabores,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "labor-nuevo",
              name: "NuevoLabor",
              component: NuevoLabor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "edit-labor/:folio",
              name: "EditLabor",
              component: NuevoLabor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "labores-nuevo",
              name: "NuevoLabores",
              component: NuevoLabores,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-labor/:id",
              name: "VerLabor",
              component: VerLabor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "riego",
              name: "Riego",
              component: Riego,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "riego-nuevo",
              name: "NuevoRiego",
              component: NuevoRiego,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "riegos-nuevo",
              name: "NuevoRiegos",
              component: NuevoRiegos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-Riego/:id",
              name: "VerRiego",
              component: VerRiego,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            // aplicados prestamos
            {
              path: "prestamo-aplicado",
              name: "PrestamoAplicado",
              component: PrestamoAplicado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-prestamo-aplicado/:id",
              name: "VerPrestamoAplicado",
              component: VerPrestamoAplicado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "prestamo",
              name: "Prestamo",
              component: Prestamo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "prestamo-nuevo",
              name: "NuevoPrestamo",
              component: NuevoPrestamo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "edit-prestamo/:folio",
              name: "EditPrestamo",
              component: NuevoPrestamo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-prestamo/:id",
              name: "VerPrestamo",
              component: VerPrestamo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "prorroga/:id",
              name: "NuevoProrroga",
              component: NuevoProrroga,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "calculos-administrativos",
              name: "CalculoAdministrativo",
              component: CalculoAdministrativo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-calculos-administrativos/:id",
              name: "VerCalculoAdministrativo",
              component: VerCalculoAdministrativo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "nomina",
              name: "CalculoAdministrativoNomina",
              component: CalculoAdministrativoNomina,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-nomina/:id",
              name: "VerCalculoAdministrativoNominaFolio",
              component: VerCalculoAdministrativoNomina,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-nomina/:periodo_inicial/:periodo_final/:empresa_id/:trabajador_id",
              name: "VerCalculoAdministrativoNomina",
              component: VerCalculoAdministrativoNomina,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "bitacora-cuadre-fiscal",
              name: "BitacoraNomina",
              component: BitacoraNomina,
              beforeEnter: (to, from, next) => {
                validateToken()
                  ? hasTheCredential(
                      "@view:schema=cuadre_fiscal\\|.*calcular_cuadre",
                      next
                    )
                  : next({ name: "Login" });
              },
            },

            {
              path: "prestacion",
              name: "Prestacion",
              component: Prestacion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-prestacion/:id",
              name: "VerPrestacion",
              component: VerPrestacion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "asistencia",
              name: "Asistencia",
              component: Asistencia,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "asistencia-nuevo",
              name: "NuevoAsistencia",
              component: NuevoAsistencia,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            // {
            //   path: "asistencia-editar/:folio",
            //   name: "EditAsistencia",
            //   component: NuevoAsistencia,
            //   beforeEnter: (to, from, next) => {
            //     validateToken() ? next() : next({ name: "Login" });
            //   }
            // },
            {
              path: "ver-asistencia/:id",
              name: "VerAsistencia",
              component: VerAsistencia,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "jornada",
              name: "Jornada",
              component: Jornada,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            // {
            //   path: "asistencia-editar/:folio",
            //   name: "EditAsistencia",
            //   component: NuevoAsistencia,
            //   beforeEnter: (to, from, next) => {
            //     validateToken() ? next() : next({ name: "Login" });
            //   }
            // },
            {
              path: "ver-jornada/:id",
              name: "VerJornada",
              component: VerJornada,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "bitacora-jornada",
              name: "BitacoraJornadas",
              component: BitacoraJornadas,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            //aplicados bonos

            {
              path: "bono-aplicado",
              name: "BonoAplicado",
              component: BonoAplicado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-bono-aplicado/:id",
              name: "VerBonoAplicado",
              component: VerBonoAplicado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "bono",
              name: "Bono",
              component: Bono,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "bono-nuevo",
              name: "NuevoBono",
              component: NuevoBono,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "bono-editar/:folio",
              name: "EditBono",
              component: NuevoBono,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-bono/:id",
              name: "VerBono",
              component: VerBono,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "bonos-nuevo",
              name: "NuevoBonos",
              component: NuevoBonos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            //aplicada caja ahorro
            {
              path: "caja-ahorro-aplicado",
              name: "CajaAhorroAplicado",
              component: CajaAhorroAplicado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-caja-ahorro-aplicado/:id",
              name: "VerCajaAhorroAplicado",
              component: VerCajaAhorroAplicado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "caja-ahorro",
              name: "CajaAhorro",
              component: CajaAhorro,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "caja-ahorro-nuevo",
              name: "NuevoCajaAhorro",
              component: NuevoCajaAhorro,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "caja-ahorro/:folio",
              name: "EditCajaAhorro",
              component: NuevoCajaAhorro,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-caja-ahorro/:id",
              name: "VerCajaAhorro",
              component: VerCajaAhorro,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "prorroga-caja-ahorro/:id",
              name: "NuevaProrrogaCA",
              component: NuevaProrrogaCA,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "pagos-caja-ahorro/:id",
              name: "NuevoPagoCA",
              component: NuevoPagoCA,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "entrega",
              name: "Entrega",
              component: Entrega,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "entrega-nuevo",
              name: "NuevoEntrega",
              component: NuevoEntrega,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "entregas-nuevo",
              name: "NuevoEntregas",
              component: NuevoEntregas,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "edit-entrega/:folio",
              name: "EditEntrega",
              component: NuevoEntrega,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-entrega/:id",
              name: "VerEntrega",
              component: VerEntrega,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "gasto",
              name: "Gasto",
              component: Gasto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "edit-gasto/:folio",
              name: "EditGasto",
              component: NuevoGasto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "gasto-nuevo",
              name: "NuevoGasto",
              component: NuevoGasto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-gasto/:id",
              name: "VerGasto",
              component: VerGasto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "gestion-de-labores",
              name: "GestionLabores",
              component: GestionLabores,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "gestion-de-labores/:id",
              name: "VerGestionLabores",
              component: VerLabor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "depuraciones",
              name: "Depuraciones",
              component: Depuraciones,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "entrada",
              name: "Entrada",
              component: Entrada,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "entrada-nuevo",
              name: "NuevoEntrada",
              component: NuevoEntrada,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-entrada/:id",
              name: "VerEntrada",
              component: VerEntrada,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "salida",
              name: "Salida",
              component: Salida,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "salida-nuevo",
              name: "NuevoSalida",
              component: NuevoSalida,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-salida/:id",
              name: "VerSalida",
              component: VerSalida,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "devoluciones-empaque",
              name: "DevolucionEmpaque",
              component: DevolucionEmpaque,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "devoluciones-empaque-nuevo",
              name: "NuevoDevolucionEmpaque",
              component: NuevoDevolucionEmpaque,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-devoluciones-empaque/:id",
              name: "VerDevolucionEmpaque",
              component: VerDevolucionEmpaque,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "solicitud-empaque",
              name: "SolicitudEmpaque",
              component: SolicitudEmpaque,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "solicitud-empaque-nuevo",
              name: "NuevoSolicitudEmpaque",
              component: NuevoSolicitudEmpaque,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ver-solicitud-empaque/:id",
              name: "VerSolicitudEmpaque",
              component: VerSolicitudEmpaque,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "requisicion",
              name: "Requisiciones",
              component: Requisiciones,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "requisicion-nuevo",
              name: "NuevaRequisicion",
              component: NuevaRequisicion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "edit-requisicion/:folio",
              name: "EditRequisicion",
              component: NuevaRequisicion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "requisicion/:id",
              name: "VerRequisicion",
              component: VerRequisicion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "traspaso",
              name: "Traspasos",
              component: Traspasos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "traspaso-nuevo",
              name: "NuevoTraspaso",
              component: NuevoTraspaso,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "traspaso/:id",
              name: "VerTraspaso",
              component: VerTraspaso,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ordenes-compra",
              name: "OrdenesCompra",
              component: OrdenesCompra,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ordenes-compra-nueva",
              name: "NuevaOrdenCompra",
              component: NuevaOrdenCompra,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ordenes-compra/:id",
              name: "VerOrdenCompra",
              component: VerOrdenCompra,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ordenes-compra-surtir/",
              name: "SurtirOrdenCompra",
              component: SurtirOrdenCompra,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
          ],
        },
        {
          path: "consultas",
          redirect: "/consultas/costos",
          name: "consultas",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "costos",
              name: "Costos",
              component: Costos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "inventario-actual",
              name: "InventarioActual",
              component: InventarioActual,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "inventario-detallado",
              name: "InventarioDetallado",
              component: InventarioDetallado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "inventario-historico",
              name: "InventarioHistorico",
              component: InventarioHistorico,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "inventario-historico-detallado",
              name: "InventarioHistoricoDetallado",
              component: InventarioHistoricoDetallado,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
          ],
        },
        {
          path: "catalogos",
          redirect: "/catalogos/cultivos",
          name: "catalogos",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "actividades",
              name: "Actividades",
              component: Actividades,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "actividad-nuevo",
              name: "NuevoActividad",
              component: NuevoActividad,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-actividad/:id",
              name: "EditarActividad",
              component: EditarActividad,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "actividades-costos",
              name: "ActividadesCostos",
              component: ActividadesCostos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "almacenes",
              name: "Almacenes",
              component: Almacenes,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },

            {
              path: "almacen-nuevo",
              name: "NuevoAlmacen",
              component: NuevoAlmacen,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-almacen/:id",
              name: "EditarAlmacen",
              component: EditarAlmacen,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "cultivos",
              name: "Cultivos",
              component: Cultivos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "cultivo-nuevo",
              name: "NuevoCultivo",
              component: NuevoCultivo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-cultivo/:id",
              name: "EditarCultivo",
              component: EditarCultivo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operadores",
              name: "Operadores",
              component: Operadores,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "operadores-nuevo",
              name: "NuevoOperador",
              component: NuevoOperador,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-operador/:id",
              name: "EditarOperador",
              component: EditarOperador,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "empresas",
              name: "Empresas",
              component: Empresas,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "empresa-nuevo",
              name: "NuevoEmpresa",
              component: NuevoEmpresa,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-empresa/:id",
              name: "EditarEmpresa",
              component: EditarEmpresa,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "productos",
              name: "Productos",
              component: Productos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "producto-nuevo",
              name: "NuevoProducto",
              component: NuevoProducto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-producto/:id",
              name: "EditarProducto",
              component: EditarProducto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "puestos",
              name: "Puestos",
              component: Puestos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "puesto-nuevo",
              name: "NuevoPuesto",
              component: NuevoPuesto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-puesto/:id",
              name: "EditarPuesto",
              component: EditarPuesto,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "servicios",
              name: "Servicios",
              component: Servicios,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "servicio-nuevo",
              name: "NuevoServicio",
              component: NuevoServicio,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-servicio/:id",
              name: "EditarServicio",
              component: EditarServicio,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "Trabajadores",
              name: "Trabajadores",
              component: Trabajadores,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "trabajador-nuevo",
              name: "NuevoTrabajador",
              component: NuevoTrabajador,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-trabajador/:id",
              name: "EditarTrabajador",
              component: EditarTrabajador,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "proveedores",
              name: "Proveedores",
              component: Proveedores,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "proveedor-nuevo",
              name: "NuevoProveedor",
              component: NuevoProveedor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-proveedor/:id",
              name: "EditarProveedor",
              component: EditarProveedor,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "clientes",
              name: "Clientes",
              component: Clientes,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "cliente-nuevo",
              name: "NuevoCliente",
              component: NuevoCliente,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-Cliente/:id",
              name: "EditarCliente",
              component: EditarCliente,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "empaques",
              name: "Empaques",
              component: Empaques,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "empaques-nuevo",
              name: "NuevoEmpaques",
              component: NuevoEmpaques,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-empaques/:id",
              name: "EditarEmpaques",
              component: EditarEmpaques,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ubicaciones",
              name: "Ubicaciones",
              component: Ubicaciones,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "ubicacion-nuevo",
              name: "NuevoUbicacion",
              component: NuevoUbicacion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-ubicacion/:id",
              name: "EditarUbicacion",
              component: EditarUbicacion,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            // Dispositivos
            {
              path: "dispositivos",
              name: "Dispositivos",
              component: Dispositivos,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "dispositivo-nuevo",
              name: "NuevoDispositivo",
              component: NuevoDispositivo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
            {
              path: "editar-dispositivo/:id",
              name: "EditarDispositivo",
              component: NuevoDispositivo,
              beforeEnter: (to, from, next) => {
                validateToken() ? next() : next({ name: "Login" });
              },
            },
          ],
        },
      ],
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/recovery",
      name: "Recovery",
      component: Recovery,
    },
    {
      path: "/recovery-change/:ambito/:mail/:token",
      name: "RecoveryPsChange",
      component: RecoveryPsChange,
    },
    {
      path: "/aviso-privacidad",
      name: "AvisoPrivacidad",
      component: AvisoPrivacidad,
    },
    {
      path: "*",
      name: "Error",
      component: Error500Page,
    },
  ];
}

router.onError((error) => {
  if (/loading chunk \d* failed./i.test(error.message)) {
    window.location.reload();
  }
});

export default router;
